module.exports = __webpack_public_path__ + "img/borderLeftTriangleWhite.df3ad0ee.svg";